// material-ui
import { useTheme } from '@mui/material/styles';
import logoIcon from 'assets/images/icons/planimator-logo-color.svg';
import greyIcon from 'assets/images/icons/Planimator Logo White black@2x.png';
import PropTypes from 'prop-types';

// ==============================|| LOGO SVG ||============================== //

const PlanimatorIcon = ({ width, white, loader, faded }) => {
  const theme = useTheme();
  // const size = loader ? 80 : width ? width : 40;
  const size = width ? width : loader ? 60 : 40;

  return faded ? (
    <img src={greyIcon} alt="vaseelah-icon" width={size} className={`${loader ? 'animate-[spin_2s_linear_infinite]' : ''}`} />
  ) : (
    <img
      src={white ? 'assets/images/icons/planimator-logo-color.svg' : logoIcon}
      alt="vaseelah-icon"
      width={size}
      className={`${loader ? 'animate-[spin_2s_linear_infinite]' : 'animate-[spin_30s_linear_infinite]'}`}
    />
  );
};

export default PlanimatorIcon;

PlanimatorIcon.proptypes = {
  width: PropTypes.number,
  white: PropTypes.bool,
  loader: PropTypes.bool,
  faded: PropTypes.bool
};
